module.exports = {
      id: "quote-usage",
      viewBox: "0 0 32 25",
      url: __webpack_public_path__ + "img/icons.789192dd.svg#quote-usage",
      toString: function () {
        return this.url;
      }
    }